var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11838_115736)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6 3.42661H14.4C8.35195 3.42661 3.42857 8.34718 3.42857 14.3918V44.546L19.9133 44.546L33.6 44.546C39.6481 44.546 44.5714 39.6254 44.5714 33.5808V14.3918C44.5714 8.34718 39.6481 3.42661 33.6 3.42661ZM20.2903 47.9726H33.6C41.5416 47.9726 48 41.5179 48 33.5808V14.3918C48 6.45471 41.5416 0 33.6 0H14.4C6.4584 0 0 6.45471 0 14.3918V45.574C0 45.582 4.0728e-05 45.5901 0.00012207 45.5982V48H19.9133L20.2903 47.9726ZM16.5 12V14.4212H12V35.9863H36V14.4212H31.5V12H28.5V14.4212H19.5V12H16.5ZM15 32.9881V22.4941H33V32.9881H15Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11838_115736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoData);
export default __webpack_public_path__ + "static/media/icon--no-data.6cba38422f5c338657b3c5a082dea596.svg";
export { ForwardRef as ReactComponent };